import React from 'react';
import { MdRecordVoiceOver } from 'react-icons/md';
import { FaGraduationCap, FaBuilding, FaUserCircle } from 'react-icons/fa';
import './Speakers.css';

const Speakers = () => {
  const speakers = [
    {
      name: 'Dr. S. Srinath',
      designation: 'Professor',
      affiliation: 'School of Physical Sciences, University of Hyderabad',
      expertise: 'Magnetism and Spintronics, Multiferroics, Nanomaterials, Thin films',
      email: 'srinath@uohyd.ac.in',
      phone: '(040)23134330(O); +91-9963268640',
      status: 'Confirmed',
      img: '/SSrinath.avif'
    },
    {
      name: 'Dr. J. Suryanarayana',
      designation: 'Professor',
      affiliation: 'Department of Physics, IIT Hyderabad',
      expertise: 'Magnetic materials, Device physics, Spintronics',
      email: 'surya@iith.ac.in',
      phone: '040 - 2301 7085',
      status: 'Confirmed',
      img: '/suryanarayana-j.avif'
    },
    {
      name: 'Dr. B R K Nanda',
      designation: 'Professor',
      affiliation: 'Department of Physics, IIT Madras',
      expertise: 'Electronic Structure, Magnetism, Topology, Electrochemistry, 2D Materials',
      email: 'nandab@iitm.ac.in',
      phone: '+91-9940417993',
      status: 'Confirmed',
      img: '/Birabar-Nanda.avif'
    },
    {
      name: 'Dr. Lokesh C. Tribedi',
      designation: 'Professor',
      affiliation: 'Department of Nuclear and Atomic Physics, TIFR Mumbai',
      expertise: 'Ion-atom-molecule collisions, Bio-molecules-PAH-Fullerene, electron-collisions',
      email: 'Lokesh@tifr.res.in',
      phone: '+91 9869264908',
      status: 'Confirmed',
      img: '/LokeshTribedi.png'
    },
    {
      name: 'Dr. B. Karthikeyan',
      designation: 'Professor',
      affiliation: 'Department of Physics, NIT-Tiruchirapalli',
      expertise: 'Nanomaterial synthesis, Optical properties and Ultraviolet sensing, Raman Spectroscopy',
      email: 'bkarthik@nitt.edu',
      phone: '+91 99943 72825',
      status: 'Confirmed',
      img: '/bkarthik.png'
    },
    {
      name: 'Prof. Prasanta Karmakar',
      designation: 'Scientific Officer (G)',
      affiliation: 'VECC Kolkata & Associate Professor, Homi Bhabha National Institute',
      expertise: 'Ion-matter interaction, ion beam development and acceleration',
      email: 'prasantak@vecc.gov.in',
      phone: '+91-9874878407',
      status: 'Confirmed',
      img: '/Prasanta-Karmakar.avif'
    },
    {
      name: 'Dr. Ujjwal Pal',
      designation: 'Sr. Principal Scientist (F) & Prof. @ AcSIR',
      affiliation: 'CSIR-IICT, Hyderabad',
      expertise: 'Photo & Electrocatalysis, Single Atom Catalyst, Water Splitting',
      email: 'ujjwalpal@iict.res.in',
      phone: '+91 99325 49107',
      status: 'Confirmed',
      img: '/Ujjwal Pal.avif'
    },
    {
      name: 'Dr. G. A. Basheed',
      designation: 'Sr. Principal Scientist',
      affiliation: 'CSIR-National Physical Laboratory (NPL), New Delhi',
      expertise: 'Magnetism, Skyrmions, Magnetic Fluid, Magnetocaloric Effect, Ferromagnetic Resonance',
      email: 'basheedga@nplindia.org',
      phone: '011-4560-8334',
      status: 'Confirmed',
      img: 'basheed.png'
    },
    {
      name: 'Dr. D. Haranath',
      designation: 'Professor',
      affiliation: 'Department of Physics, NIT Warangal',
      expertise: '2D Materials, Energy Harvesting and Storage Devices, Photonics',
      email: 'haranath@nitw.ac.in',
      phone: '+91-870-2462554',
      status: 'Confirmed',
      img: '/ph-haranath.avif'
    },
    {
      name: 'Dr. P. Saidi Reddy',
      designation: 'Professor',
      affiliation: 'Department of Applied Sciences, NIT Goa',
      expertise: 'Nanoscale Matter, Radar Absorption Materials',
      email: 'psreddy@nitgoa.ac.in',
      phone: '+91-9049108036',
      status: 'Confirmed',
      img: '/Saidi-Parne.avif'
    },
    {
      name: 'Dr. C Kamal',
      designation: 'Associate Professor',
      affiliation: 'RRCAT, Indore',
      expertise: '2D Materials, Electronic Structure, Quantum Materials',
      email: 'ckamal@rrcat.gov.in',
      phone: '+91-9893937269',
      status: 'Confirmed',
      img: '/kamal.avif'
    },
    {
      name: 'Dr. V. Ganeshan',
      designation: 'Scientist -F',
      affiliation: 'Central Electrochemical Research Institute, Karaikudi',
      expertise: 'Semiconductors and oxide materials for sensing and catalytic applications, Biosensors',
      email: 'vganesh@cecri.res.in',
      phone: '+91 94433 20794',
      status: 'Confirmed',
      img: '/V ganesh.avif'
    },
    {
      name: 'Dr. S. Gokul Raj',
      designation: 'Associate Professor',
      affiliation: 'Department of Physics, Pondicherry University',
      expertise: 'Growth of Single Crystals, Solid State Phenomena, Optical, Electrical and Magnetic Materials',
      email: 'gokulraj@pondiuni.ac.in',
      phone: '+91 94440 39559',
      status: 'Confirmed',
      img: '/gokul raj.avif'
    },
    {
      name: 'Dr. K. Prabhu',
      designation: 'Associate Professor',
      affiliation: 'Department of Electronics and Communication Engineering, NIT-K Surathkal',
      expertise: 'Optics and Photonics',
      email: 'prabuk@nitk.edu.in',
      phone: '+91-9884888408, +91-8778227300',
      status: 'Confirmed',
      img: '/Prabu.avif'
    },
    {
      name: 'Dr. Y. Ashok Kumar Reddy',
      designation: 'Assistant Professor',
      affiliation: 'Department of Science & Humanities, IIITDM Kancheepuram',
      expertise: 'Optoelectronic Devices',
      email: 'akreddy@iiitdm.ac.in',
      phone: '+91-6302121030',
      status: 'Confirmed',
      img: '/ashok.avif'
    }
  ];

  return (
    <div className="speakers-page speakers-page-padding">
      {/* Header Section */}
      <div className="speakers-page-header">
        <div className="speakers-container">
          <h1 className="speakers-page-title"><MdRecordVoiceOver /> KeyNote speakers</h1>
          </div>
      </div>

      <div className="speakers-container">
        <div className="speakers-grid">
          {speakers.map((speaker, index) => (
            <div className="speakers-card speakers-keynote-card" key={index}>
              <div className="speakers-img-wrapper">
                {speaker.img ? (
                  <img src={speaker.img} alt={speaker.name} className="speakers-img" />
                ) : (
                  <div className="speakers-placeholder-icon">
                    <FaUserCircle />
                  </div>
                )}
              </div>
              <div className="speakers-info">
                <h3 className="speakers-name">{speaker.name}</h3>
                <div className="speakers-designation">
                  <FaGraduationCap className="speakers-icon" />
                  <span>{speaker.designation}</span>
                </div>
                <div className="speakers-affiliation">
                  <FaBuilding className="speakers-icon" />
                  <span>{speaker.affiliation}</span>
                </div>
                <div className="speakers-topic">
                  <p className="speakers-expertise">{speaker.expertise}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Speakers;
